/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {Box, Checkbox, List, ListItemButton} from "@mui/material";
import ArgosButton from "../Buttons/ArgosButton";
import ListItemText from "@mui/material/ListItemText";

interface SelectableListProps {
  items: { id: string, name: string }[];
  selectedItems: string[];
  setSelectedItems: any
  disabled: boolean
}

/**
 * Renders vertical list of items with checkboxes and select all/deselect all buttons
 */
const SelectableList: React.FC<SelectableListProps> = ({items, selectedItems, setSelectedItems, disabled}) => {
  const handleSelectAll = () => {
    setSelectedItems(items.map(item => item.id));
  };

  const handleDeselectAll = () => {
    setSelectedItems([]);
  };

  const handleToggle = (id: string) => {
    setSelectedItems((prevSelected: any) =>
      prevSelected.includes(id) ? prevSelected.filter((item: any) => item !== id) : [...prevSelected, id]
    );
  };

  return (
    <Box>
      <ArgosButton disabled={disabled} onClick={handleSelectAll}>Select All</ArgosButton>
      <ArgosButton disabled={disabled} onClick={handleDeselectAll}>Deselect All</ArgosButton>
      <List>
        {items.map(item => (
          <ListItemButton key={item.id} onClick={() => handleToggle(item.id)} disabled={disabled}>
            <Checkbox
              checked={selectedItems.includes(item.id)}
            />
            <ListItemText primary={item.name}/>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default SelectableList;